import FactoryTableInterface from './factoryTableInterface';

import Headers from '../../../collections/headerList';
import { COLUMN_TYPES as CT } from '../../../../consts';

const col = {};

col[CT.realtyType] = new Headers.HeaderItem();
col[CT.realtyType]
    .addLabel('Тип', 'objectTypeId')
    .addLabel('Район');

col[CT.description] = new Headers.HeaderItem();
col[CT.description].addLabel('Адрес, описание');

col[CT.descriptionAndType] = new Headers.HeaderItem();
col[CT.descriptionAndType].addLabel('Адрес, описание');

col[CT.price] = new Headers.HeaderItem();
col[CT.price]
    .addLabel('Цена', 'price');

col[CT.priceAndPay] = new Headers.HeaderItem();
col[CT.priceAndPay]
    .addLabel('Цена/Плата', 'price');

col[CT.priceAndPricePerMeter] = new Headers.HeaderItem();
col[CT.priceAndPricePerMeter]
    .addLabel('Цена', 'price')
    .addLabel('Цена за м²', 'pricePerSquareMeter');

col[CT.area] = new Headers.HeaderItem();
col[CT.area].addLabel('Площадь', 'squareTotal');

col[CT.building] = new Headers.HeaderItem();
col[CT.building]
    .addLabel('Этаж')
    .addLabel('Дом');

col[CT.contacts] = new Headers.HeaderItem();
col[CT.contacts].addLabel('Контакты');

col[CT.moreProperty] = new Headers.HeaderItem();
col[CT.moreProperty].addLabel('Параметры');

col[CT.land] = new Headers.HeaderItem();
col[CT.land]
    .addLabel('Дом')
    .addLabel('Участок');

col[CT.date] = new Headers.HeaderItem();
col[CT.date].addLabel('Дата', 'inserted');

/** --- rent apartments */
const rentApartmentsColumns = [
  CT.realtyType,
  CT.description,
  CT.priceAndPay,
  CT.moreProperty,
  CT.area,
  CT.contacts,
  CT.date
];

const rentApartmentsHeaders = new Headers.HeaderList();
rentApartmentsColumns.map(id => rentApartmentsHeaders.addHeader(col[id]));

/** --- rent commercials */
const rentCommercialsColumns = [
  CT.realtyType,
  CT.description,
  CT.price,
  CT.area,
  CT.moreProperty,
  CT.contacts,
  CT.date
];
const rentCommercialsHeaders = new Headers.HeaderList();
rentCommercialsColumns.map(id => rentCommercialsHeaders.addHeader(col[id]));

/** --- rentDaily apartments */
const rentDailyApartmentsColumns = [
  CT.realtyType,
  CT.description,
  CT.priceAndPay,
  CT.moreProperty,
  CT.contacts,
  CT.date
];
const rentDailyApartmentsHeaders = new Headers.HeaderList();
rentDailyApartmentsColumns.map(id => rentDailyApartmentsHeaders.addHeader(col[id]));

/** --- sale apartments */
const saleApartmentsColumns = [
  CT.realtyType,
  CT.description,
  CT.priceAndPricePerMeter,
  CT.area,
  CT.building,
  CT.contacts,
  CT.date
];
const saleApartmentsHeaders = new Headers.HeaderList();
saleApartmentsColumns.map(id => saleApartmentsHeaders.addHeader(col[id]));

/** --- sale commercials */
const saleCommercialsColumns = [
  CT.realtyType,
  CT.description,
  CT.price,
  CT.area,
  CT.moreProperty,
  CT.contacts,
  CT.date
];
const saleCommercialsHeaders = new Headers.HeaderList();
saleCommercialsColumns.map(id => saleCommercialsHeaders.addHeader(col[id]));

/** --- sale garages */
const saleGaragesColumns = [
  CT.realtyType,
  CT.description,
  CT.price,
  CT.area,
  CT.moreProperty,
  CT.contacts,
  CT.date
];
const saleGaragesHeaders = new Headers.HeaderList();
saleGaragesColumns.map(id => saleGaragesHeaders.addHeader(col[id]));

/** --- sale lands */
const saleLandsColumns = [
  CT.realtyType,
  CT.description,
  CT.price,
  CT.land,
  CT.contacts,
  CT.date
];
const saleLandsHeaders = new Headers.HeaderList();
saleLandsColumns.map(id => saleLandsHeaders.addHeader(col[id]));

class FactoryGrid extends FactoryTableInterface {
  getHeaders () {
    const section = this.dealType + '_' + this.realtyType;

    switch (section) {
      case 'rent_apartments': return rentApartmentsHeaders;
      case 'rent_commercials': return rentCommercialsHeaders;
      case 'rentDaily_apartments': return rentDailyApartmentsHeaders;

      case 'sale_apartments': return saleApartmentsHeaders;
      case 'sale_commercials': return saleCommercialsHeaders;
      case 'sale_garages': return saleGaragesHeaders;
      case 'sale_lands': return saleLandsHeaders;
    }
    return null;
  }

  getColumns () {
    const section = this.dealType + '_' + this.realtyType;

    switch (section) {
      case 'rent_apartments': return rentApartmentsColumns;
      case 'rent_commercials': return rentCommercialsColumns;
      case 'rentDaily_apartments': return rentDailyApartmentsColumns;

      case 'sale_apartments': return saleApartmentsColumns;
      case 'sale_commercials': return saleCommercialsColumns;
      case 'sale_garages': return saleGaragesColumns;
      case 'sale_lands': return saleLandsColumns;
    }
    return [];
  }
}

export default FactoryGrid;



// WEBPACK FOOTER //
// ./src/classes/builder/search/factories/factoryGrid.js